// Imports
import Vue from "vue";
import Router from "vue-router";
import { updatePageSEO } from "@/utils/seo";
import { detectLang } from "@/lang/langs";

Vue.use(Router);
//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash };
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      component: () => import("@/layouts/base/Index.vue"),
      children: [
        {
          path: "/",
          name: "Home",
          component: () => import("@/views/website/Home.vue"),
          meta: { ws: true }
        },
        {
          path: "/sign-up",
          component: () => import("@/views/home/SignUp.vue")
        },
        {
          path: "/feature",
          component: () => import("@/views/website/Features.vue"),
          meta: { ws: true }
        },
        {
          path: "/ai-staff",
          component: () => import("@/views/website/AiStaff.vue"),
          meta: { ws: true }
        },
        {
          path: "/logistics",
          component: () => import("@/views/website/Logistics.vue"),
          meta: { ws: true }
        },
        {
          path: "/payment",
          component: () => import("@/views/website/Payments.vue"),
          meta: { ws: true }
        },
        {
          path: "/pricing",
          component: () => import("@/views/website/Pricing.vue"),
          meta: { ws: true, navSolid: true }
        },
        {
          path: "/cases",
          component: () => import("@/views/website/Cases.vue"),
          meta: { ws: true, navSolid: true }
        },
        {
          path: "/question",
          alias: "/help",
          component: () => import("@/views/website/Help.vue"),
          meta: { ws: true, navSolid: true }
        },
        {
          path: "/for-china-sellers",
          component: () => import("@/views/website/ForChinaSellers.vue"),
          meta: { ws: true }
        },
        {
          path: "/for-global-sellers",
          component: () => import("@/views/website/ForGlobalSellers.vue"),
          meta: { ws: true }
        },
        {
          path: "/about-us",
          component: () => import("@/views/home/AboutUs.vue"),
          // 改版后是新官网版式：浅色首屏，导航实心
          meta: { ws: true, navSolid: true }
        },
        {
          path: "/register-agreement",
          component: () => import("@/views/home/RegisterAgreement.vue")
        },

        {
          path: "/success",
          component: () => import("@/views/home/Success.vue")
        },
        {
          path: "/activation",
          component: () => import("@/views/home/activation.vue")
        },

        {
          path: "/template-index",
          component: () => import("@/views/template/index.vue")
        },
        {
          path: "/template-list",
          component: () => import("@/views/template/list.vue")
        },
        {
          path: "/template-detail",
          component: () => import("@/views/template/detail.vue")
        },
        {
          path: "/user-index",
          component: () => import("@/views/template/user_index.vue"),
          meta: {
            needLogin: true
          }
        },
        {
          path: "/balance",
          component: () => import("@/views/template/balance.vue"),
          meta: {
            needLogin: true
          }
        },
        {
          path: "/buyed",
          component: () => import("@/views/template/buyed.vue"),
          meta: {
            needLogin: true
          }
        },
        {
          path: "/income",
          component: () => import("@/views/template/income.vue"),
          meta: {
            needLogin: true
          }
        },
        {
          path: "/withdrawal",
          component: () => import("@/views/template/withdrawal.vue"),
          meta: {
            needLogin: true
          }
        },
        {
          path: "/consume",
          component: () => import("@/views/template/consume.vue"),
          meta: {
            needLogin: true
          }
        },
        {
          path: "/template-detail-custom",
          component: () => import("@/views/template/detail_custom.vue"),
          meta: {
            needLogin: true
          }
        },
        {
          path: "/privacy-policy",
          component: () => import("@/views/article/PrivacyPolicy.vue")
        },
        {
          path: "/consumer-agreement",
          component: () => import("@/views/article/ConsumerAgreement.vue")
        },
        {
          path: "/terms-service",
          component: () => import("@/views/article/TermsService.vue")
        },
        {
          path: "/user-agreement",
          component: () => import("@/views/article/UserAgreement.vue")
        },

      ]
    },
    {
      path: "/sign-in",
      component: () => import("@/views/SignIn.vue")
    },
  ]
});
router.beforeEach(function(to, from, next) {
  if (to.meta.needLogin) {
    if (localStorage.getItem("DROPSHOPUSERINFO")) {
      next();
    } else {
      next({ name: "Home" });
    }
  } else {
    next();
  }
});

// ==================== SEO 配置 ====================
// 标题/描述按语种分文件维护（src/lang/seo/<sign>.js），缺失的语种回退英文
// Route change SEO update
router.afterEach((to) => {
  const locale = detectLang();
  updatePageSEO(to.path, locale);
});

// Init SEO on first load
const initLocale = detectLang();
updatePageSEO(window.location.pathname, initLocale);

export default router;
